import config from '@/config';
import fetchWrapper from '@/services/fetchWrapper.service';

export async function getArtistQr() {
  const { response, data } = await fetchWrapper.get(
    `${config.apis.api.url}/artist/qr-code/`,
    {
      injectToken: true,
    }
  );

  if (response.status === 404) {
    return null;
  }

  if (!response.ok) {
    throw new Error(data?.error_message || data?.error || 'Unable to load artist QR code');
  }

  return data;
}

export async function ensureArtistQr() {
  const { response, data } = await fetchWrapper.post(
    `${config.apis.api.url}/artist/qr-code/`,
    {
      injectToken: true,
      body: {},
    }
  );

  if (!response.ok) {
    throw new Error(data?.error_message || data?.error || 'Unable to generate artist QR code');
  }

  return data;
}
